import { Component, OnInit, OnChanges, Input, Output, SimpleChanges, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { formatDate } from '@angular/common'
// services
import { MessageService } from "../../../../services/message.service";
import { MasterService } from "../../../../services/master.service";
import { StoreService } from "../../../../services/store.service";
import { SecurityService } from '../../../../services/security.service'
//
import * as languageLibrary from '../../../../services/language'
import { formatCurrency } from "src/app/utils/format";
import { clean } from "src/app/utils/numeric";
import { Subscription } from "rxjs";

import { SALE_TYPES, SAVE_DEBOUNCE_MILLIS } from "src/app/constants/sale";
import moment from 'moment'

@Component({
    selector: "contract",
    templateUrl: "./contract.component.html",
    styleUrls: ["./contract.component.scss"],
    standalone: false
})
export class DealContractComponent implements OnInit, OnChanges, OnDestroy {
    //
    @Input() isUnLock: boolean = true

    // sale id
    @Input() saleId: number | null = null

    @Input() saleType: number = 0

    /** Lot presets from the corporate setup screen.  */
    @Input() presets = null

    //
    @Input() buyerType = null

    //
    @Input() isQuote: boolean = true

    //
    protected sold: string | null = null

    //
    private buyerId: number = 0

    //
    private saleVehicleId: number = 0

    //  An associative array of sale types with the id as the key
    protected saleTypes: Record<number, string> = SALE_TYPES

    //
    protected loading: boolean = false

    // save the language
    protected language: any = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'

    // set all words
    protected words = languageLibrary.language

    //
    protected ttl: number = 0

    protected accessories: number = 0

    protected down: number = 0

    protected totalSalePrice: number = 0

    protected driveOutPrice: number = 0

    protected allowance: number = 0

    protected payoff: number = 0

    protected financed: number = 0

    protected salesTax: number = 0

    protected salesTaxRate: number = 0

    //
    protected fees: Object[] = []
    //
    protected products: number = 0

    private termsId: number = 0

    //
    protected errorsCatalog = {
        'username': 'User Name',
        'password': 'Password',
        'corporateName': 'Corporate Name',
        'firstName': 'First Name',
        'middleName': 'Middle Name',
        'lastName': 'Last Name',
        'suffix': 'Suffix',
        'dealNumber': 'Deal Number',
        'entityType': 'Entity Type',
        'city': 'city',
        'state': 'State',
        'street1': 'Street',
        'zipcode': 'Zip code',
        'salesPrice': 'Sales Price',
        'bodyType': 'Body Type',
        'majorColorCode': 'Color',
        'make': 'Make',
        'model': 'model',
        'modelYear': 'Year',
        'vin': 'VIN Number'
    }

    /** */
    protected txdmv: any = {}

    protected form: FormGroup = this.fb.group({
        baseSalePrice: [0, []]
    })

    protected product: number = 0

    protected productCount: any;

    protected stage: string | null = null;

    // A handle to navbar event messages so we can unsubscribe later.
    private navbarWatcher: Subscription | null = null

    /** Listen for component events and make decisions. */
    private componentWatcher: Subscription | null = null

    /** A setTimeout watcher to delay computations during times of rapid changes (first load) */
    private watcher: ReturnType<typeof setTimeout> = null

    /** Keeps track of committed pricing changes as opposed to every key event in the input. */
    protected price: number = 0

    get feeable(): boolean { return ((this.saleType) && (['Cash deal', 'Outside', 'BHPH'].includes(this.saleTypes[this.saleType]))) }
    get termable(): boolean { return ((this.financed > 0) && (this.saleType) && (['Outside', 'BHPH'].includes(this.saleTypes[this.saleType]))) }
    get outside(): boolean { return ((this.saleType) && (this.saleTypes[this.saleType] === 'Outside')) }
    get bhph(): boolean { return ((this.saleType) && (this.saleTypes[this.saleType] === 'BHPH')) }
    get wholesale(): boolean { return ((this.saleType) && (this.saleTypes[this.saleType] === 'Wholesale')) }

    constructor(private route: ActivatedRoute, private ms: MessageService,
        private master: MasterService, private store: StoreService,
        public security: SecurityService, private fb: FormBuilder) {

        this.navbarWatcher = this.ms.channelComponents$.subscribe(res => {
            if (res.message == 'setPermissions') {
                // permissions on user list
                this.setAtributes(res.value)
            }
        })
    }

    ngOnInit() {
        this.saleId = parseInt(this.route.snapshot.params['id'])
        if (!this.saleId || isNaN(this.saleId) || (this.saleId <= 0)) {
            this.saleId = null
        }

        this.componentWatcher = this.ms.channelComponents$.subscribe((event) => {
            if (!event || !event.message) {
                return
            }

            switch (event.message) {
                case 'saleCreated':
                    if (event.value <= 0) {
                        this.saleId = null
                        return
                    }

                    this.saleId = event.value
                    break
                case 'saleRead':
                    this.form.get('baseSalePrice').setValue(formatCurrency(event.value.baseSalePrice), { emitEvent: false })
                    this.price = event.value.baseSalePrice
                    this.totalSalePrice = event.value.totalSalePrice
                    this.driveOutPrice = event.value.driveOutPrice
                    this.sold = event.value.sold
                    break
                case 'soldChanged':
                    this.sold = event.value
                    break
                case 'buyerRead':
                case 'buyerAdded':
                case 'buyerChanged':
                    const buyer = event.value

                    const buyerId = parseInt(buyer.id)
                    if (isNaN(buyerId) || (buyerId < 0) || (this.buyerId == buyerId)) {
                        this.buyerId = 0
                        return
                    }

                    this.buyerId = buyerId
                    break
                case 'buyerDiscarded':
                    this.buyerId = 0
                    break
                case 'vehicleRead':
                    this.saleVehicleId = parseInt(event.value.id)
                    break
                case 'vehicleAdded':
                case 'vehicleChanged':
                    const vehicle = event.value
                    if (!vehicle) {
                        return
                    }

                    const vehicleId = parseInt(vehicle.id)
                    if (isNaN(vehicleId) || (vehicleId < 0)) {
                        return
                    }

                    this.saleVehicleId = vehicleId

                    const price = parseFloat(vehicle.price)
                    if ((!price) || isNaN(price) || (price <= 0)) {
                        return
                    }

                    const currentPrice = clean(this.form.get('baseSalePrice').value)
                    if (currentPrice == price) { // price didn't change
                        return
                    }

                    this.form.get('baseSalePrice').setValue(formatCurrency(price), { emitEvent: false })
                    this.changed(null, false)

                    break
                case 'vehicleDiscarded':
                    this.form.get('baseSalePrice').setValue(formatCurrency(0), { emitEvent: false })
                    this.saleVehicleId = 0
                    this.changed(null, false)
                    break
                case 'tradeRead':
                    const meta = event.value
                    if (!meta) {
                        this.allowance = 0
                        this.payoff = 0
                        this.financed = 0
                        return
                    }

                    this.allowance = parseFloat(meta.allowance)
                    this.payoff = parseFloat(meta.payoff)
                    break
                case 'tradeAdded':
                case 'tradeChanged':
                    const trades = event.value
                    if (!trades) {
                        this.allowance = 0
                        this.payoff = 0
                        this.financed = 0
                        this.calculateTotal(true)
                        return
                    }

                    this.allowance = parseFloat(trades.allowance)
                    this.payoff = parseFloat(trades.payoff)
                    this.calculateTotal(true)
                    break
                case 'ttlRead':
                    this.fees = event.value.fees
                    this.salesTax = event.value.salesTax || 0
                    this.salesTaxRate = event.value.salesTaxRate || 0
                    this.ttl = event.value.value || 0
                    this.calculateTotal(false)
                    break
                case 'ttlChanged':
                    console.log(`DealContractComponent.ngOnInit: ttlChanged event received, salesTax=${event.value.salesTax}`)
                    this.fees = event.value.fees
                    this.salesTax = event.value.salesTax || 0
                    this.salesTaxRate = event.value.salesTaxRate || 0
                    this.ttl = event.value.value || 0
                    this.calculateTotal(event.value.save || false)
                    break
                case 'productsChanged':
                    this.products = event.value.value
                    this.productCount = event.value.productCount
                    this.calculateTotal(event.value.save || false)
                    break
                case 'accessoriesRead':
                case 'accessoriesChanged':
                    this.accessories = event.value.value
                    this.calculateTotal(event.value.save || false)
                    break
                case 'downsChanged':
                    this.down = event.value.value
                    this.calculateTotal(event.value.save || false)
                    break
            }

            this.checkComponentState()
        })
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }

        if (changes.isUnLock) {
            this.checkComponentState()
        }

        if (changes.presets) {
            if (!this.presets) {
                return
            }

            const enableBHPH = this.presets['enableBHPH']

            this.saleTypes = SALE_TYPES
            if (!enableBHPH) { // remove BHPH from available finance types?
                this.saleTypes = {}
                const keys = Object.keys(SALE_TYPES)
                for (const key in keys) {
                    if (!key || !SALE_TYPES[key]) {
                        continue
                    }

                    if (SALE_TYPES[key] === 'BHPH') {
                        continue
                    }

                    this.saleTypes[key] = SALE_TYPES[key]
                }
            }
        }
    }

    ngOnDestroy() {
        if (this.componentWatcher) {
            this.componentWatcher.unsubscribe()
        }

        if (this.navbarWatcher) {
            this.navbarWatcher.unsubscribe()
        }
    }

    /**
     * Keep the form locked unless other factors allow editing.
     */
    private checkComponentState = () => {
        if (!this.editable()) {
            this.form.disable({ emitEvent: false })
            return
        }

        this.form.enable({ emitEvent: false })
    }

    /**
    * Handle blur and commit events on the base sale price currency input.
    * @param {Event} e
    * @param {boolean} [init=false] Indicates whether or not the change was the initial load/read.
    */
    public changed = (e: Event | null, init: boolean = false): void => {
        const basePrice = clean(this.form.get('baseSalePrice').value)
        if (!basePrice || isNaN(basePrice) || (basePrice < 0)) {
            this.price = 0
            return
        }

        this.price = basePrice
        this.calculateTotal(!init)

        if (init) {
            return
        }

        this.ms.channelComponents$.emit({ message: 'salePriceChanged', section: 'contract', value: { baseSalePrice: this.price, totalSalePrice: this.totalSalePrice, driveOutPrice: this.driveOutPrice } })
    }

    public editable = () => {
        if (!this.isUnLock) {
            return false
        }

        if (!this.saleId || (this.saleId <= 0)) {
            return false
        }

        if (!this.buyerId || (this.buyerId <= 0)) {
            return false
        }

        if (!this.saleVehicleId || (this.saleVehicleId <= 0)) {
            return false
        }

        return true
    }

    /**
     * 
     * @param e 
     * @param activeTab 
     */
    protected setActiveTab = (e: Event, activeTab: string) => {
        if (e) {
            e.stopPropagation()
            e.preventDefault()
        }

        const links: NodeListOf<HTMLAnchorElement> = document.querySelectorAll<HTMLAnchorElement>('#sale-contract-tabs.nav-tabs > .nav-item > a.nav-link')
        links.forEach((link) => {
            link.classList.remove('active')
        })

        const tabs: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>('#sale-contract-tab-content.tab-content > section.tab-pane')
        tabs.forEach((tab) => {
            tab.classList.remove('active')
            tab.classList.remove('show')
        })

        const tabLink: HTMLAnchorElement = document.getElementById(`${activeTab}-link`) as HTMLAnchorElement
        if (tabLink) {
            tabLink.classList.add('active')
        }

        const tab: HTMLElement = document.getElementById(`${activeTab}-tab`) as HTMLElement
        if (tab) {
            tab.classList.add('active')
            tab.classList.add('show')
        }
    }

    /**
     * Compute the contract totals based on current information.
     * @param save Indicates whether or not the new totals should be saved.
     */
    private calculateTotal = (save: boolean): void => {
        const prevFinanced = this.financed
        const prevTotalSalePrice = this.totalSalePrice

        this.totalSalePrice = clean(this.form.get('baseSalePrice').value) + this.accessories - this.allowance
        this.driveOutPrice = this.totalSalePrice + this.ttl + this.products
        this.financed = this.driveOutPrice - this.down + this.payoff

        if (!this.editable()) {
            return
        }

        if (!save) {
            return
        }

        const financeChanged = (this.financed !== prevFinanced)
        const totalSalePriceChanged = (this.totalSalePrice !== prevTotalSalePrice)

        this.save(() => {
            if (totalSalePriceChanged) {
                this.ms.channelComponents$.emit({ message: 'totalSalePriceChanged', section: 'contract', value: { baseSalePrice: this.price, totalSalePrice: this.totalSalePrice, driveOutPrice: this.driveOutPrice } })
            }

            if (financeChanged) {
                this.ms.channelComponents$.emit({ message: 'financedChanged', section: 'contract', value: this.financed })
            }
        })
    }

    /**
     * 
     * @param notify
     */
    private save = async (callback: () => void) => {
        if (!this.saleId || (this.saleId <= 0)) {
            return
        }

        const payload = {
            salePrice: clean(this.form.get('baseSalePrice').value),
            totalSalePrice: this.totalSalePrice,
            driveOutPrice: this.driveOutPrice
        }

        await this.master.patch(`sales/${this.saleId}`, payload, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            if (!callback) {
                return
            }

            callback()
        })
    }

    public setAtributes = (permissions: any[]): void => {

    }

    public openTXDMV = (): void => {
        /*
        this.loading = true
        this.master.post('webDealerDispatcher', {
        activity: 'read',
        saleId: this.saleId,
        lotId: this.store.lotSelected,
        primaryKeyId: this.inventory.inventoryId ? this.inventory.inventoryId : null
        }, res => {
        this.loading = false
        if (res) {
        this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
        return
        }

        if (res.status !== 200) {
        this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
        return
        }

        let id = null
        this.txdmv = res.data
        if (!this.txdmv.body || (this.txdmv.body.length <= 0)) {
        return
        }

        for (let index = 0; index < this.txdmv.body.length; index++) {
        this.txdmv.body[index].message = JSON.parse(this.txdmv.body[index].message)
        if (this.txdmv.body[index].message['ax21:success'] == 'true') {
        id = this.txdmv.body[index].message['ax21:titleId']
        }
        }

        this.txdmv.body.forEach(el => {
        el.message['ax21:titleId'] = id
        el.message['ax21:fees'] = el.message['ax21:fees'] && typeof el.message['ax21:fees'] === 'object' ? [] : el.message['ax21:fees']
        // el.message['ax21:messages']=el.message['ax21:messages'] && typeof el.message['ax21:messages']==='object'?[]:el.message['ax21:messages']
        })
        })
        */
    }

    public checkTitleTXDMV = (): void => {
        /*
        this.loading = true
        this.master.post('webDealerDispatcher', {
        activity: 'checkTitleStatus',
        checkStatusData: {
        dealersConfigId: this.txdmv.integrationUseParameters.dealer.id,
        primaryKeyId: this.txdmv.header.inventory,
        userId: this.txdmv.integrationUseParameters.user.userId,
        username: this.txdmv.integrationUseParameters.user.username,
        dealerId: this.txdmv.integrationUseParameters.dealer.dealerId,
        password: this.txdmv.integrationUseParameters.user.password,
        titleId: this.txdmv.body[0].message['ax21:titleId'],
        }
        }, res => {
        this.loading = false
        if (!res) {
        this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
        return
        }

        if (res.status !== 200) {
        this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
        return
        }

        this.openTXDMV()
        this.ms.sendMessage("alert", { type: "success", text: this.words[this.language]['success'] })
        })
        */
    }

    // upload title aplication
    public uploadTitle = (): void => {
        /*
        if (!this.buyerType || !this.inventory) {
        return
        }

        let color = this.txdmv.colorsCatalog.find(el => el['name'] == this.inventory.data['exteriorColor'])
        const make = this.txdmv.makesCatalog.find(el => el['name'] == this.inventory.data['make'].toUpperCase())

        // error make
        if (make == undefined) {
        this.ms.sendMessage("alert", { type: "warning", text: 'The make or model of the vehicle is not compatible with webDealer' });
        return
        }

        let uploadTitleData = {
        dealersConfigId: this.txdmv.integrationUseParameters.dealer.id,
        primaryKeyId: this.txdmv.header.inventory,
        userId: this.txdmv.integrationUseParameters.user.userId,
        username: this.txdmv.integrationUseParameters.user.username,
        dealerId: this.txdmv.integrationUseParameters.dealer.dealerId,
        password: this.txdmv.integrationUseParameters.user.password,
        corporateName: this.store.userAccount['user'].corporateName,
        createTimestamp: moment().format('yyyy-MM-DD'),
        contractDate: moment(this.buyerType['createdAt']).format('yyyy-MM-DD'),
        dealNumber: this.inventory['stockNumber'],
        firstName: this.buyerType['firstName'],
        lastName: this.buyerType['lastName'],
        entityType: this.buyerType['code'] ? this.buyerType['code'] : '',
        city: this.buyer['city'],
        state: this.buyer['state'],
        street1: this.buyer['address'],
        zipcode: this.buyer['zipCode'],
        idJurisdiction: this.buyer['issuer'], //2
        idNumber: this.buyer['number'],
        idType: this.buyerType.contactIdentifications.length > 0 ? this.buyerType.contactIdentifications[0].identificationType['code'] : '',
        salesPrice: this.form.get('baseSalePrice').value,
        bodyType: this.inventory.data['type'], // 2
        majorColorCode: color.code,
        make: make.code,
        model: this.inventory.data['model'],
        modelYear: this.inventory.data['modelYear'],
        vin: this.inventory.data['vinNumber'],
        }

        for (const property in uploadTitleData) {
        if (uploadTitleData[property] == '') {
        this.ms.sendMessage("alert", { type: "info", text: `${this.errorsCatalog[property]} cannot be empty` });
        return
        }
        }
        uploadTitleData['middleName'] = this.buyerType['middleName']
        uploadTitleData['suffix'] = this.buyerType['suffix']

        this.loading = true
        this.master.post('webDealerDispatcher', {
        activity: 'uploadTitle',
        uploadTitleData: uploadTitleData
        }, res => {
        this.loading = false
        if (!res) {
        this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
        return
        }

        if (res.status !== 200) {
        this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
        return
        }

        this.ms.sendMessage("alert", { type: "success", text: this.words[this.language]['success'] });
        this.openTXDMV()
        })
        */
    }


    //
    public openWebSite = () => {
        window.open('https://webdealer.txdmv.gov/title/login.do#')
    }

}
